import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FaqElementComponent from './FaqElementComponent';

import { FaqThemeContainer } from './FaqThemeComponentStyle';
class FaqThemeComponent extends Component {
    render() {
        const { theme, hashId } = this.props;

        return (
            <FaqThemeContainer>
                <h2>{theme.label}</h2>
                {theme.faqs.map(faq => (
                    <FaqElementComponent key={faq.id} faq={faq} hashId={hashId} />
                ))}
            </FaqThemeContainer>
        );
    }
}

FaqThemeComponent.propTypes = {
    theme: PropTypes.object.isRequired
};

export default FaqThemeComponent;



// WEBPACK FOOTER //
// ./src/components/pages/faq/FaqThemeComponent.js